import { render, staticRenderFns } from "./IndentationBlock.vue?vue&type=template&id=23cf2b12&"
import script from "./IndentationBlock.vue?vue&type=script&lang=js&"
export * from "./IndentationBlock.vue?vue&type=script&lang=js&"
import style0 from "./IndentationBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports